import React from 'react';
import InspectionOtherFormView from "./InspectionOtherForm-view";
import Spinner from "../../../../common/components/Spinner";
import {useInspectionOtherUIContext} from "../InspectionOtherUIContext";


const InspectionOtherForm = () => {
  const {
    orderID,
    shumaId,
    firmShumaID,
    formik,
    options,
    cityChangeProps,
    loading,
    handleDataSubmit
  } = useInspectionOtherUIContext();

  return loading ? <Spinner/> : (
    <InspectionOtherFormView
      orderID={orderID}
      shumaID={shumaId}
      firmShumaID={firmShumaID}
      formik={formik}
      options={options}
      cityChangeProps={cityChangeProps}
      handleDataSubmit={handleDataSubmit}
    />
  );
};

export default InspectionOtherForm;

